






































































import { Component, Vue } from 'vue-property-decorator'
import { Alert, Tag } from 'element-ui'
import SearchForm from '@/components/common/SearchForm.vue'
import TableForm from '@/components/common/TableForm.vue'
import $Api from '@api'
import { DateTime } from '@/utils/filters'
import { accountState, canOpenAccount, openingCommand, validMid } from '@/utils/third-customer'
import { ThirdCustomer, ThirdCustomerChannel, OpeningPreview, OpeningOperation } from '@/api/model/third-customer'

@Component({ components: { SearchForm, TableForm, 'el-alert': Alert, 'el-tag': Tag } })
export default class ThirdCustomerPage extends Vue {
    search = { current: 1, size: 10, mid: '', channelId: null, status: null, customerId: '' }
    rows: ThirdCustomer[] = []
    total = 0
    channels: ThirdCustomerChannel[] = []
    statuses = [{ value: 1, key: 'active' }, { value: 2, key: 'pending' }, { value: 0, key: 'failed' }]
    certificationLabels = ['person', 'contacts', 'face', 'identity']
    loading = false
    openingVisible = false
    lockedTarget = false
    verifying = false
    submitting = false
    refreshingId: string | null = null
    preview: OpeningPreview | null = null
    form = { mid: '', channelId: 14, reason: '' }
    historyVisible = false
    historyLoading = false
    historyMid = ''
    history: OpeningOperation[] = []
    private loadSequence = 0
    private previewSequence = 0
    private historySequence = 0
    state = accountState
    canOpen = canOpenAccount
    date = DateTime

    t(key: string): string { return this.$t('thirdCustomer.' + key) as string }
    get openingChannels(): ThirdCustomerChannel[] { return this.channels.filter(channel => channel.openingSupported) }
    get isReopening(): boolean { return !!(this.preview && this.preview.account && accountState(this.preview.account) === 'active') }
    get dialogTitle(): string { return this.isReopening ? this.t('reopen') : this.t('open') }
    get readyToSubmit(): boolean {
        try { openingCommand(this.preview, this.form.mid, this.form.channelId, this.form.reason); return !this.verifying && !this.submitting }
        catch (_) { return false }
    }
    statusColor(row: ThirdCustomer): string {
        return ({ active: 'success', pending: 'warning', failed: 'danger', unknown: 'info' })[accountState(row)]
    }
    created(): void {
        this.getData()
        $Api.thirdCustomerService.channels().subscribe(channels => { this.channels = channels }, error => this.reportError(error))
    }
    async getData(page = {}): Promise<void> {
        Object.assign(this.search, page)
        if (this.search.mid && !validMid(this.search.mid)) { this.$message.error(this.t('invalidMid')); return }
        const sequence = ++this.loadSequence
        this.loading = true
        try {
            const result = await $Api.thirdCustomerService.list({ ...this.search }).toPromise()
            if (sequence !== this.loadSequence) return
            this.rows = result.list || []; this.total = result.total
        } catch (error) { if (sequence === this.loadSequence) this.reportError(error) }
        finally { if (sequence === this.loadSequence) this.loading = false }
    }
    searchAccounts(): void { this.search.current = 1; this.getData() }
    showOpening(row?: ThirdCustomer): void {
        this.invalidatePreview()
        this.form = { mid: row ? row.mid : '', channelId: row ? Number(row.channelId) : 14, reason: '' }
        this.lockedTarget = !!row; this.openingVisible = true
        if (row) this.verifyUser()
    }
    invalidatePreview(): void { ++this.previewSequence; this.preview = null; this.verifying = false }
    async verifyUser(): Promise<void> {
        if (!validMid(this.form.mid)) { this.$message.error(this.t('invalidMid')); return }
        const sequence = ++this.previewSequence
        this.preview = null; this.verifying = true
        try {
            const preview = await $Api.thirdCustomerService.preview({ mid: this.form.mid, channelId: this.form.channelId }).toPromise()
            if (sequence === this.previewSequence) this.preview = preview
        } catch (error) { if (sequence === this.previewSequence) this.reportError(error) }
        finally { if (sequence === this.previewSequence) this.verifying = false }
    }
    async submitOpening(): Promise<void> {
        if (this.submitting) return
        let command
        try { command = openingCommand(this.preview, this.form.mid, this.form.channelId, this.form.reason) }
        catch (error) { this.$message.error(this.t(error.message)); return }
        this.submitting = true
        try {
            const result = await $Api.thirdCustomerService.open(command).toPromise()
            this.openingVisible = false
            if (result.status === 0) this.$message.error(result.failReason || this.t('failed'))
            else this.$message.success(result.status === 1 ? this.t('active') : this.t('accepted'))
            await this.getData()
        } catch (error) { this.reportError(error) }
        finally { this.submitting = false }
    }
    async refreshAccount(row: ThirdCustomer): Promise<void> {
        if (this.refreshingId) return
        this.refreshingId = row.id
        try { await $Api.thirdCustomerService.refresh({ mid: row.mid, channelId: Number(row.channelId), recordId: row.id }).toPromise(); await this.getData() }
        catch (error) { this.reportError(error) }
        finally { this.refreshingId = null }
    }
    async showHistory(row: ThirdCustomer): Promise<void> {
        const sequence = ++this.historySequence
        this.history = []; this.historyMid = row.mid; this.historyVisible = true; this.historyLoading = true
        try { const result = await $Api.thirdCustomerService.history(row.id).toPromise(); if (sequence === this.historySequence) this.history = result }
        catch (error) { if (sequence === this.historySequence) this.reportError(error) }
        finally { if (sequence === this.historySequence) this.historyLoading = false }
    }
    reportError(error): void { this.$message.error(error && error.message || this.t('requestFailed')) }
}
